import * as React from "react";

import styles from "./styles.scss";

const Main = (props: React.PropsWithChildren<unknown>) => {
  return <div className={styles.main}>{props.children}</div>;
};

export default Main;
